(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-feature-callouts"] && !Shopify.designMode) return;
  try {
    
  // Lightweight JS for interaction
  document.addEventListener('DOMContentLoaded', function() {
    const hotspots = document.querySelectorAll('.fc-hotspot-btn');

    // Close popups when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.fc-hotspot-btn')) {
        hotspots.forEach(btn => btn.classList.remove('is-active'));
      }
    });

    // Toggle specific popup on click
    hotspots.forEach(btn => {
      btn.addEventListener('click', function(e) {
        // Prevent bubbling to document immediately
        e.stopPropagation();
        
        // Optional: Close others when opening a new one
        hotspots.forEach(b => {
          if (b !== btn) b.classList.remove('is-active');
        });

        this.classList.toggle('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
